import * as uiv from "uiv";
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import vSelect from "vue-select";
import vMultiSelect from 'vue-multiselect'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core'
library.add(fab, far, fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(uiv);

import { Checkbox } from 'buefy'
Vue.use(Checkbox);

import { Radio } from 'buefy'
Vue.use(Radio);

import { Notification } from 'uiv'
Vue.prototype.$notify = Notification.notify

import { VTooltip } from 'v-tooltip'
Vue.directive('tooltip', VTooltip)

Vue.component("v-select", vSelect);
Vue.component('v-multi-select', vMultiSelect);
Vue.use(require('vue-moment'));

const $ = require('jquery')
// Lo declaramos globalmente
window.$ = $;

const token = localStorage.getItem('token')
if (token) {
    store.state.api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    store.commit('user/AUTH', true)
}

import filters from './utils/filters';
for (let name in filters) {
  Vue.filter(name, filters[name]);
}

Vue.config.productionTip = false

// inicializar vue
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
